import { CustomError } from './custom.error.js';

class HttpError extends CustomError {
    getExtras() {
        return {
            errorCode: this.errorCode,
            state: this.status,
            response: this.body,
            url: this.response?.url
        };
    }
    constructor(message, settings){
        super(message), this.name = "HttpError";
        this.errorCode = settings.errorCode;
        this.status = settings.status;
        this.request = settings.request;
        this.body = settings.body;
        this.response = settings.response;
    }
}

export { HttpError };
//# sourceMappingURL=http.error.js.map
